<template>
  <div class="withdraw-logs">
    <van-nav-bar title="提现记录" left-arrow @click-left="$router.back()" fixed placeholder />

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        class="log-list"
      >
        <div v-for="item in list" :key="item.id" class="log-item">
          <div class="log-header">
            <span class="log-no">单号：{{ item.withdraw_no }}</span>
            <span :class="['log-status', getStatusClass(item.status)]">
              {{ formatStatus(item.status) }}
            </span>
          </div>
          
          <div class="log-amount-box">
            <span class="currency">¥</span>
            <span class="amount">{{ item.amount }}</span>
          </div>

          <div class="log-body">
            <div class="log-row">
              <span class="label">收款姓名：</span>
              <span class="value">{{ item.alipay_name }}</span>
            </div>
            <div class="log-row">
              <span class="label">支付宝账号：</span>
              <span class="value">{{ item.alipay_account }}</span>
            </div>
            <div class="log-row">
              <span class="label">申请时间：</span>
              <span class="value">{{ item.created_at }}</span>
            </div>
            <div class="log-row" v-if="item.handled_at">
              <span class="label">处理时间：</span>
              <span class="value">{{ item.handled_at }}</span>
            </div>
            <div class="log-row reject-reason" v-if="item.status == 2 && item.reject_reason">
              <span class="label">驳回原因：</span>
              <span class="value">{{ item.reject_reason }}</span>
            </div>
            <div class="log-row voucher-row" v-if="item.status == 1 && item.payment_voucher">
              <span class="label">打款凭证：</span>
              <span class="value">
                <van-image
                  width="60"
                  height="60"
                  fit="cover"
                  :src="item.payment_voucher"
                  @click="previewImage(item.payment_voucher)"
                />
              </span>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'

export default {
  name: 'WithdrawLogs',
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pageSize: 15
    }
  },
  methods: {
    async onLoad() {
      try {
        const res = await this.$common.cusHttp(
          this,
          `/api/saas_finance.php?action=withdraw_list&page=${this.page}&pageSize=${this.pageSize}`,
          {},
          'get'
        )
        const data = JSON.parse(res.data)
        
        if (this.refreshing) {
          this.list = []
          this.refreshing = false
        }

        if (data.status && data.data && data.data.list) {
          const items = data.data.list
          this.list.push(...items)
          this.page++

          if (items.length < this.pageSize) {
            this.finished = true
          }
        } else {
          this.finished = true
        }
      } catch (err) {
        console.error('加载提现记录失败:', err)
        this.finished = true
      } finally {
        this.loading = false
      }
    },
    onRefresh() {
      this.finished = false
      this.loading = true
      this.page = 1
      this.onLoad()
    },
    formatStatus(status) {
      const map = {
        0: '待审核',
        1: '已打款',
        2: '已驳回'
      }
      return map[status] || '未知'
    },
    getStatusClass(status) {
      const map = {
        0: 'text-orange',
        1: 'text-green',
        2: 'text-red'
      }
      return map[status] || ''
    },
    previewImage(url) {
      if (url) {
        ImagePreview([url])
      }
    }
  }
}
</script>

<style scoped>
.withdraw-logs {
  min-height: 100vh;
  background-color: #f7f8fa;
}

.log-list {
  padding: 12px;
}

.log-item {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
}

.log-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.log-no {
  font-size: 13px;
  color: #999;
}

.log-status {
  font-size: 14px;
  font-weight: bold;
}

.text-orange {
  color: #ff976a;
}

.text-green {
  color: #07c160;
}

.text-red {
  color: #ee0a24;
}

.log-amount-box {
  text-align: center;
  padding: 10px 0 20px;
  border-bottom: 1px dashed #f5f5f5;
  margin-bottom: 16px;
}

.currency {
  font-size: 18px;
  font-weight: bold;
  color: #323233;
  margin-right: 4px;
}

.amount {
  font-size: 32px;
  font-weight: bold;
  color: #323233;
}

.log-body {
  font-size: 13px;
  color: #666;
}

.log-row {
  display: flex;
  margin-bottom: 8px;
  line-height: 1.4;
}

.log-row .label {
  color: #999;
  width: 85px;
  flex-shrink: 0;
}

.log-row .value {
  flex: 1;
  word-break: break-all;
}

.reject-reason .value {
  color: #ee0a24;
}

.voucher-row {
  align-items: flex-start;
  margin-top: 12px;
}
</style>
